<template>
  <v-card>
    <v-card-title>Upload Vocabulary List</v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12" md="6">
          <v-select
            :items="languageList"
            v-model="baseLanguage"
            hide-details
            :label="$t('app.baseLanguage')"
            outlined />
        </v-col>
        <v-col cols="12" md="6">
          <v-select
            :items="languageList"
            v-model="learningLanguage"
            hide-details
            :label="$t('app.learningLanguage')"
            outlined />
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="topic"
            hide-details
            :label="$t('myVocabulary.topic')"
            outlined />
        </v-col>
        <v-col cols="12" md="6">
          <v-file-input
            :clearable="false"
            hide-details
            prepend-icon=""
            append-icon="attach_file"
            show-size
            persistent-hint
            accept=".xls, .xlsx"
            label="Translation file"
            v-model="file"
            outlined />
          <div class="d-flex pt-2 pl-3">
            <v-icon small color="red" class="pr-2">info</v-icon>
            <span>Download <a :href="downloadUrl">Example.xlsx</a> and follow the formatting instructions.</span>
          </div>
        </v-col>
        <v-col cols="12">
          <v-btn
            :disabled="!file"
            @click="fileUpload"
            color="blue"
            class="white--text">
            Upload
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import snackbarMethods from '@/mixins/snackbar';

export default {
  name: 'Admin',
  mixins: [snackbarMethods],
  data: () => ({
    baseLanguage: '',
    learningLanguage: '',
    topic: '',
    file: null,
    downloadUrl: null,
  }),
  computed: {
    languageList() {
      return this.$lang.getAllNames();
    },
    isValidToUpload() {
      return this.baseLanguage.length > 0 && this.learningLanguage.length > 0;
    },
  },
  methods: {
    resetFields() {
      this.baseLanguage = '';
      this.learningLanguage = '';
    },
    async fileUpload() {
      const storageRef = this.$firebase.storage().ref(this.file.name);

      try {
        await storageRef.put(this.file);
        this.file = null;

        this.setSnackbarSuccess({ text: 'File successfully uploaded' });
      } catch {
        this.setSnackbarError({ text: 'File could not be uploaded' });
      }
    },
    async getTemplateDownloadUrl() {
      try {
        const storageRef = this.$firebase.storage().ref('Language-Nerd-Example.xlsx');

        await storageRef.getDownloadURL().then((url) => {
          this.downloadUrl = url;
        });
      } catch {
        this.setSnackbarError({ text: 'File not found in bucket' });
      }
    },
    async getTranslationFile(name) {
      let file = null;

      try {
        file = await import(`@formatter/src/output/${name}.js`).then((res) => res.default);
      } catch {
        this.setSnackbarError({ text: 'File not found' });
      }

      return file;
    },
    async updateVocabularyListInFirestore() {
      if (!this.isValidToUpload) {
        this.setSnackbarError({ text: 'Languages need to be selected' });
        return;
      }

      const langCodes = `${this.$lang.getCode(this.baseLanguage)}_${this.$lang.getCode(this.learningLanguage)}`;
      const vocabularyList = await this.getTranslationFile(langCodes);

      const newVocabularyList = {};
      vocabularyList.forEach((item, index) => {
        newVocabularyList[index] = item;
      });

      await this.$firestore
        .collection('public')
        .doc('vocabularies')
        .collection(langCodes)
        .doc('vocabularies')
        .set(newVocabularyList, { merge: true })
        .then(() => {
          this.resetFields();
          this.setSnackbarSuccess({ text: `Vocabulary list successfully updated` });
        });
    },
  },
  async created() {
    await this.getTemplateDownloadUrl();
  },
};
</script>
